//import the embeddable class
var TrackedMailEmbeddable = require("../../embeddables/TrackedMailEmbeddable") ;

var trackedMailController = new TrackedMailEmbeddable();

module.exports = trackedMailController ;